/*
 * @Descripttion:
 * @version:
 * @Author: wangliuyang
 * @Date: 2023-06-16 13:35:05
 * @LastEditors: wangliuyang
 * @LastEditTime: 2023-06-16 13:35:15
 */
/*
 * @Descripttion:
 * @version:
 * @Author: wangliuyang
 * @Date: 2023-06-12 13:32:55
 * @LastEditors: wangliuyang
 * @LastEditTime: 2023-06-13 10:41:44
 */
/*
 * @Descripttion:
 * @version:
 * @Author: wangliuyang
 * @Date: 2023-04-07 11:10:41
 * @LastEditors: wangliuyang
 * @LastEditTime: 2023-05-25 11:18:33
 */
import axios from 'axios'
import Vue from 'vue'
import qs from 'qs'
import 'babel-polyfill' // ie8-11
import store from '@/store'
import router from '@/router'
import { md5 } from './md52';
import {JAVAHOSTURL,BXEVN,VERSION } from 'basecommon/js/default.js';
import { trackApiRequest } from 'basecommon/js/userTrack'
// axios.defaults.baseURL = 'https://gateway.gaosiedu.com/student';
// const appKey = 'gaosi!@$%^@#';
const appKey = 'gaosionline';
const partner = '10025';


const instance2 = axios.create({
    baseURL: JAVAHOSTURL[BXEVN],
  });

// axios.defaults.baseURL = 'https://test.gaosiedu.com/restapi';
// axios.defaults.baseURL = 'https://test.gsviponline.com/restapi';
//axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

export default function request1(option, success, fail) {

    console.log('进入request11111')
    // 登录支付不显示
    if (router.history.current.name != 'payWeixin') {
        Vue.prototype.$loading('数据加载中')
    }
    const token = store.state.user.LoginToken?store.state.user.LoginToken:'';

    let generateSignGet1;
    let generateSignPost1;
    if(option.type == 'get'){
        generateSignGet1 = generateSignGet(option.query, token, partner, appKey)
    }else{
        generateSignPost1= generateSignPost(option.data, partner, appKey)
    }

    const trackParams = option.type == 'get' ? Object.assign({}, option.query || {}) : (option.data || {});
    let url;
    if (option.query) {
        option.query = sortQuery(option.query);
    }

    if (option.query == '') {
        url = option.api;
    } else {
        url = option.api + '?' + option.query;
    }

    if (option.type == 'post') {
        option.data = option.data;
    }

    option.query = option.query;

    url = option.defaultUrl ? option.defaultUrl + url : url //defaultUrl为Mock数据接口
    trackApiRequest({
        url,
        method: option.type,
        params: trackParams,
        extra: {
            baseURL: JAVAHOSTURL[BXEVN],
            appName: '高思教育官网'
        }
    });

    instance2({
        url: url,
        method: option.type,
        data: option.data || {},
        headers: {
            'ptoken': token || '',
            'uToken': token || '',
            Accept: 'application/json',
            'Content-Type': 'application/json; charset=utf-8',
            'Access-Control-Allow-Origin': '*',
            credentials: 'same-origin',
            withCredentials: true,
            partner: partner,
            'X-Request-BuriedPoint':'client='+encodeURIComponent('思泉素养官网')+';version='+VERSION,
            sign:option.type=='post'?generateSignPost1:generateSignGet1,
        }
    }).then(function(res) {
        // 微信支付不显示
        if (router.history.current.name != 'payWeixin') {
            Vue.prototype.$loading.close()
        }
        var res = res.data;
        if (res.code == 200) {
            success(res)
            console.log(res)
        } else if (res.error_code == 1001 || res.error_code == 1009) {
            Vue.prototype.$toast.center('未登录，请先登录');
            //router.push('/loginCode')
            localStorage.removeItem('user');
            router.replace({
                path: "/loginCode",
                query: {
                    redirect: router.currentRoute.fullPath
                }
            })
        } else if (res.error_code == 1005) {
            Vue.prototype.$toast.center('网络故障')
        } else if (res.error_code == 1007) {
            Vue.prototype.$toast.center('微信用户openid或者学员信息获取失败')
        } else if (res.error_code == 1008) {
            Vue.prototype.$toast.center('登录过期')
            router.push('/loginCode')
        } else if (res.error_code == 1010) {
            Vue.prototype.$toast.center('图形验证码输入错误')
        } else if (res.error_code == 429) {
            Vue.prototype.$toast.center('请求过于频繁，请稍候再试')
        } else if (res.error_code == 10002) {
            Vue.prototype.$toast.center('用户信息未完善')
            router.push('/p-Data')
        } else {
            if (fail != null) {
                fail(res)
            } else {
                Vue.prototype.$toast.center(res.Message)
            }

        }
    }).catch((err) => {
        Vue.prototype.$loading.close()
            // if(err.response.status == 429){
            //   Vue.prototype.$toast.center('请求过于频繁，请稍候再试')
            // }else {
            //   alert(err)
            // }
    })
};

export const generateSignPost=(params, partner, appKey)=> {
    const str = `partner=${partner}&${JSON.stringify(params)}${appKey}`;
    return md5(str);
  }

// function generateSignPost(params, partner, appKey, token){
//     console.log(params, qs.stringify(params), JSON.stringify(params));
//     const str = `partner=${partner}&utoken=${token}&${JSON.stringify(params)}${appKey}`;
//     // const str = 'appid=10031&timestamp=1579159120207&token=93ff3d71472c4abf9052c57eb211882f&PageIndex=1&PageSize=40&OperatorRoleName=%E8%AF%BE%E7%A8%8B%E9%A1%BE%E9%97%AE&OperatorId=0320&IntentionSchoolId=DPBJ063&SessionKey=93ff3d71472c4abf9052c57eb211882f&DistributeState=-1@#￥%1'
//     console.log(str);
//     return md5(str);
// };

function generateSignGet(params, token, partner, appKey) {
    console.log(params);
    console.log(token);
    console.log(partner);
    console.log(appKey);
    // 把{a: 1, b:2}变成 ['a=1', 'b=2']
    let parArr = [];
    for (let key in params) {
      // 把所有key值变成小写
      const newkey = key.toLowerCase();
      console.log(key);
      // 为空的值 不参与生成签名
      if (Array.isArray(params[key])) {
        params[key] = params[key].sort((a, b) => a.localeCompare(b));
        params[key] = params[key].join('');
        parArr.push(`${newkey}=${params[key]}`);
      } else if (params[key] !== '') {
        parArr.push(`${newkey}=${params[key]}`);
      }
    }
    parArr.push(`partner=${partner}`);
    if (token) {
      parArr.push(`utoken=${token}`);
    }
    // 排序
    parArr = parArr.sort();
    // 把['a=1', 'b=2'] 变成 'a=1$b=2'
    let str = '';
    parArr.forEach(value => {
      str += `${value}&`;
    });
    str = str.slice(0, str.length - 1);
    str += appKey;
    console.log('////get/////')
    console.log(str);
    return md5(str);
  }


function sortQuery(obj) {
    // 先获取所有属性名
    var keys = [];
    for (var key in obj) {
        keys.push(key);
    }
    // 排序
    keys.sort();
    // 导出新的对象
    var r = {};
    for (var i = 0; i < keys.length; i++) {
        key = keys[i];
        r[key] = obj[key];
    }
    // 将排序好的对象转为请求参数
    var str = '';
    for (var k in r) {
        str += k + '=' + r[k] + '&'
    }
    return str.substr(0, str.length - 1);
};



// WEBPACK FOOTER //
// ./src/assets/js/request2.js